import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * BrowserRouter keeps the previous scroll position on navigation, so a page
 * opened from the (mobile) menu could appear already scrolled down, looking as
 * if nothing happened. Scroll to the top on every route change, or to the
 * element referenced by the hash (e.g. /suporte#faq) once it has rendered.
 */
const ScrollToTop = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (!hash) {
      window.scrollTo(0, 0);
      return;
    }

    const id = decodeURIComponent(hash.slice(1));
    let attempts = 0;
    let timer: ReturnType<typeof setTimeout>;

    // Page content is often loaded asynchronously, so retry for a short while
    const scrollToHash = () => {
      const el = document.getElementById(id);
      if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      } else if (attempts++ < 20) {
        timer = setTimeout(scrollToHash, 100);
      } else {
        window.scrollTo(0, 0);
      }
    };
    scrollToHash();

    return () => clearTimeout(timer);
  }, [pathname, hash]);

  return null;
};

export default ScrollToTop;
